<template>
<!-- 商品好评监控 -->
    <div>
        <top-title name="商品评价分析" desc="只记录热卖商品sku排名前100"></top-title>
        <div class="goodsMonitor">
            <div class="content">
                <!-- 按钮区块 -->
                <div class="titBtns">
                    <div class="leftBtn">
                        <button class="refreshBtn"> <img src="../../assets/images/refresh.png" alt="" class="refresh"> 更新</button>
                        <button class="synchroBtn">同步店铺商品</button>
                    </div>
                    <button class="exportBtn">导出数据</button>
                </div>

                <!-- 表格 -->
                <el-table
                    :data="tableData"
                    :header-cell-style="{background:'#FAFAFA'}"
                    style="width: 100%;">

                    <el-table-column prop="hotRanking" label="热卖排名"></el-table-column>
                    <el-table-column label="商品名称" width="400">
                        <template slot-scope="scope">
                            <div class="shopInfo">
                                <img src="" class="avar" alt="">
                                <span class="tit">{{scope.row.shopName}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="skuId" label="SKU ID"></el-table-column>
                    <el-table-column prop="goodId" label="商品编码"></el-table-column>
                    <el-table-column prop="goodMoney" label="商品金额"></el-table-column>
                    <el-table-column prop="good" label="好评数"></el-table-column>
                    <el-table-column prop="center" label="中评数"></el-table-column>
                    <el-table-column prop="bad" label="差评数"></el-table-column>
                    <el-table-column prop="total" label="评价总数"></el-table-column>
                    <el-table-column prop="praiseRate" label="好评率"></el-table-column>
                    <el-table-column prop="praiseRate" label="计算好评" width="180">
                        <template slot-scope="scope">
                            <div class="countBox">
                                <span> 好评率 
                                    <el-input v-model="scope.row.goodRate" placeholder="100" maxLength="3" style="width: 50px; height: 28px;"></el-input> % 
                                </span>
                                <span>需删中差评：<span style="color:#FE4D45; lineHeight: 27px;">9</span> </span>
                                <span>或新增好评：<span style="color:#FE4D45;">9</span> </span>
                            </div>
                        </template>
                    </el-table-column>

                </el-table>

                <!-- 分页 -->
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 30, 50, 100]"
                    :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper"
                    class="pagination"
                    :total="66">
                </el-pagination>

            </div>
        </div>
    </div>
</template>

<script>
import topTitle from '../../components/top-title'

export default {
    components: {
        topTitle
    },
    data() {
        return {
            // 表格数据
            tableData: [],
            // 当前页
            currentPage: 1
        }
    },
    created() {
        for (let i=0; i < 5; i++) {
            this.tableData.push({
                hotRanking: i,
                shopName: 'Nintendo Switch 任天堂家用游戏机续航版增强版 掌机NS体感游戏机 国行Switch游戏机',
                skuId: '10388052458',
                goodId: '10084211235',
                goodMoney: '58.00',
                good: 830,
                center: 7,
                bad: 2,
                total: 900,
                praiseRate: '99.6%',
                goodRate: null,
            })
        }
    },
    methods: {
        /**
         * 分页事件
         */
        handleSizeChange() {},
        handleCurrentChange() {}
    },
}
</script>

<style lang="scss" scoped>
.goodsMonitor {
    box-sizing: border-box;
    padding: 20px;
    min-width: 1366px;
    button {
        margin: 0;
        padding: 0 12px;
        height: 32px;
        line-height: 30px;
        border: none;
        outline: none;
        border-radius:3px;
        background-color: #fff;
        cursor: pointer;
    }
    .content {
        box-sizing: border-box;
        padding: 24px 28px 30px;
        background:rgba(255,255,255,1);
        box-shadow:0px 4px 8px rgba(0,0,0,0.1);
        border-radius:6px;
        .titBtns {
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #333;
            font-size: 14px;
            font-weight: 400;
            margin-bottom: 20px;
            .leftBtn {
                display: flex;
                .refreshBtn {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 98px;
                    color: #fff;
                    background:rgba(254,77,69,1);
                    margin-right: 12px;
                    .refresh {
                        width: 14px;
                        height: 14px;
                        margin-right: 4px;
                    }
                }
                .synchroBtn {
                    width: 108px;
                    height: 32px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #000;
                    border:1px solid rgba(0,0,0,0.14901960784313725);
                }
            }
            .exportBtn {
                width: 98px;
                height: 32px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #000;
                border:1px solid rgba(0,0,0,0.14901960784313725);
            }
        }
        .shopInfo {
            display: flex;
            align-items: center;
            height: 100px;
            .avar {
                flex-shrink: 0;
                width: 58px;
                height: 58px;
                margin-right: 16px;
                border-radius: 50%;
                background-color: #F6F6F6;
            }
            .tit {line-height: 20px; color: #7F85E9;}
        }
        .countBox {
            display: flex;
            flex-direction: column;
            
        }
        .pagination {
            margin-top: 20px;
            text-align: right;
        }
    }
}
</style>
<style lang="scss">
.goodsMonitor {
    .countBox {
        .el-input__inner {
            padding: 0 10px;
            height: 28px !important;
            line-height: 28px;
        }
    }
}
</style>